import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const SintraLayout = ({ children }) => {
  return (
    <div className="sintra-layout">
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default SintraLayout;
